import React from 'react';
import ReactDOM from 'react-dom';
import * as styles from './styles.scss';

const Modal = ({
    className,
    children,
    toggle,
    elementId = 'modal',
}) => ReactDOM.createPortal(
    <div className={styles.modal}>
        <div
            className={styles.back}
            onClick={toggle}
            role="presentation"
        />
        <div className={`${styles.popup}${className ? ` ${className}` : ` ${styles.standard}`}`}>
            <button
                className={styles.close}
                disabled={!toggle}
                onClick={toggle}
                aria-label="Close"
            />
            <div className={styles.body}>
                {children}
            </div>
        </div>
    </div>,
    document.getElementById(elementId),
);

export default Modal;
